import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import { Button } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { useTransmitInvoice } from '@/core/domain/invoice/invoice/invoice.hooks';
import { Forms } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import ModalLoadingOverlay from '@/components/_common/ModalLoadingOverlay';

export function InvoiceTransmitTecnoSpeed() {
  const { invoiceId, handleSubmit, instanceForms } = useInvoiceFormContext();

  const transmitInvoice = useTransmitInvoice();

  const handleTransmitClick = async () => {
    try {
      await Promise.all(
        Object.keys(instanceForms).map((key: unknown) =>
          instanceForms[key as keyof Forms]?.validateFields().catch((error) => {
            throw new error(`validationFields: ${error.message}`);
          }),
        ),
      );

      await handleSubmit()
        .then(async () => await transmitInvoice.mutateAsync(Number(invoiceId)))
        .catch((error) => {
          throw new error(`transmissionError: ${error.message}`);
        });
    } catch (err) {
      const error = err as Error;

      if (error.message.startsWith('validationFields')) {
        notificationError(err, {
          description:
            'Há campos obrigatórios que precisam ser preenchidos na aba de dados.',
        });
      }

      if (error.message.startsWith('transmissionError')) {
        notificationError(err);
      }
    }
  };

  return (
    <>
      {transmitInvoice.isLoading && (
        <ModalLoadingOverlay
          messages={['Transmitindo nota...', 'Validando dados da nota...']}
        />
      )}

      <Button
        loading={transmitInvoice.isLoading}
        block
        type="primary"
        disabled={!hasPermissions([Authorities.FISCAL_INVOICE_TRANSMIT])}
        onClick={handleTransmitClick}
      >
        Transmitir
      </Button>
    </>
  );
}
